module.exports = __webpack_public_path__ + "img/nav-about-movie.6a205a0.webp";